// Stripe payment form (components/StripePaymentElement.js). Stripe translates
// its own fields; these are the strings around them.
export const checkout = {
  en: {
    "checkout.declined":
      "Your card has been declined. Please contact your bank or try a different payment method.",
    "checkout.trialStarted": "Your free trial has started!",
    "checkout.thanks": "Thank you for your purchase!",
    "checkout.startTrial": "Start free trial",
    "checkout.pay": "Pay",
  },
};
